import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { fetchUserTestData } from '../../apiService';

const columns = [
  { id: 'user_name', label: 'Name', minWidth: 170 },
  { id: 'email', label: 'email', minWidth: 100 },
  { id: 'years_of_exp', label: 'Years Of Experience', minWidth: 100 },
  {
    id: 'start_time',
    label: 'Started On',
    minWidth: 170,
  },
  {
    id: 'correct_answers',
    label: 'Correct Answers',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'score',
    label: 'Score',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'time',
    label: 'Finsihed Time(minutes)',
    minWidth: 170,
    align: 'center',
  },
];

function createData(name, code, population, size) {
  const density = 123;
  const test = 222;
  return { name, code, population, size, density,test };
}



function ExamsTable(props) {
  const [page, setPage] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // Load test data
  React.useEffect(() => {
    async function fetchData() {
     
        const testData = await fetchUserTestData(props.exam_id);
        setRows(testData["usersTests"]);
      
    }
    fetchData();
  }, [props.exam_id]);
  
    

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default  ExamsTable;